<div class="mapa-flotante">
  <app-flotante
    [recorridos]="recorridos"
    (recorridosChange)="onRecorridosChange($event)"
    [vehiculos]="reportes?.length"
  ></app-flotante>
</div>
<app-mapa-facil-v2
  [zoom]="12"
  [style]="tipoMapaBase"
  [mapId]="'MapaColectivosComponent'"
  [mapasPersonalizados]="mapasPersonalizados"
  [allowedEntityTypes]="allowedTypes"
  [includeGeometriesOnStyleChange]="true"
  (mapReady)="onMapReady($event)"
></app-mapa-facil-v2>
